import React from 'react';
import PropTypes from 'prop-types';

function ChatFooter({ children }) {
  return <div className="chat-area-footer">{children}</div>;
}

ChatFooter.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ChatFooter;
